import type { AxiosError, AxiosResponse, InternalAxiosRequestConfig } from "axios";
import Env from "@/core/config/env";

const DEBUG_NETWORK = Env.isDevelopment && Env.debugNetwork;

function getRequestUrl(config?: { baseURL?: string; url?: string }): string | undefined {
  if (!config?.url) {
    return undefined;
  }

  if (/^https?:\/\//i.test(config.url) || !config.baseURL) {
    return config.url;
  }

  return new URL(config.url, config.baseURL).toString();
}

function logNetworkEvent(
  event: "request" | "response" | "error",
  details: Record<string, unknown>,
): void {
  if (!DEBUG_NETWORK) {
    return;
  }

  console.debug(`[network:${event}]`, details);
}

export function requestLogger(request: InternalAxiosRequestConfig): InternalAxiosRequestConfig {
  logNetworkEvent("request", {
    method: request.method?.toUpperCase(),
    url: getRequestUrl(request),
    params: request.params,
  });

  return request;
}

export function responseLogger<T>(response: AxiosResponse<T>): AxiosResponse<T> {
  logNetworkEvent("response", {
    method: response.config.method?.toUpperCase(),
    url: getRequestUrl(response.config),
    status: response.status,
  });

  return response;
}

export function errorLogger(error: AxiosError): Promise<never> {
  logNetworkEvent("error", {
    method: error.config?.method?.toUpperCase(),
    url: getRequestUrl(error.config),
    status: error.response?.status,
    code: error.code,
    message: error.message,
  });

  return Promise.reject(error);
}
